import { render } from "./Partners.vue?vue&type=template&id=2dd0d7c4"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"
script.render = render

export default script